<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import request from '@/utils/request'
import config from '@/config'

export default {
  name: 'App',
  data() {
    return {
      settings: {
        site_name: '',
        site_description: '',
        site_keywords: '',
        contact_phone: '',
        contact_email: '',
        address: '',
        wechat_qrcode: '',
        douyin_qrcode: '',
        icp_number: '',
        copyright_text: ''
      }
    }
  },
  methods: {
    // 获取网站设置
    async fetchSettings() {
      try {
        const settingsPath = config.api.settings.public
        if (!settingsPath) {
          throw new Error('API 路径未定义')
        }
        const res = await request.get(settingsPath)
        
        // 检查返回的数据格式（注意：res.data.data 才是实际数据）
        if (res.data && res.data.code === 200 && res.data.data) {
          const apiData = res.data.data
          
          if (Array.isArray(apiData)) {
            // 如果是数组格式，转换为对象
            const settingsMap = apiData.reduce((acc, item) => {
              if (item.setting_key && item.setting_value !== undefined) {
                acc[item.setting_key] = item.setting_value
              }
              return acc
            }, {})
            this.settings = { ...this.settings, ...settingsMap }
          } else if (typeof apiData === 'object') {
            // 如果已经是对象格式，直接合并
            this.settings = { ...this.settings, ...apiData }
          }
        } else {
          console.warn('API返回数据格式不正确:', res.data)
        }
        this.updateMetaInfo()
      } catch (error) {
        console.error('获取网站设置失败:', error)
        this.updateMetaInfo()
      }
    },
    
    // 更新网站 meta 信息
    updateMetaInfo() {
      // 确保 settings 存在且是对象
      if (!this.settings || typeof this.settings !== 'object') {
        console.warn('网站设置数据格式不正确')
        return
      }
      
      // 更新网站标题（只在有site_name时更新）
      if (this.settings.site_name) {
        document.title = this.settings.site_name
      }
      
      // 更新 meta 描述
      let metaDescription = document.querySelector('meta[name="description"]')
      if (!metaDescription) {
        metaDescription = document.createElement('meta')
        metaDescription.name = 'description'
        document.head.appendChild(metaDescription)
      }
      metaDescription.content = this.settings.site_description || ''
      
      // 更新 meta 关键词
      let metaKeywords = document.querySelector('meta[name="keywords"]')
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta')
        metaKeywords.name = 'keywords'
        document.head.appendChild(metaKeywords)
      }
      metaKeywords.content = this.settings.site_keywords || ''
    }
  },
  created() {
    this.fetchSettings()
  },
  // 监听路由变化，动态更新页面标题
  watch: {
    '$route'(to) {
      if (this.settings && this.settings.site_name) {
        // 根据路由设置不同的页面标题
        const pageTitle = to.meta.title || ''
        document.title = pageTitle ? `${pageTitle} - ${this.settings.site_name}` : this.settings.site_name
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
}

.page-container {
  /* 移除padding-top */
}

.section {
  padding: 60px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 2em;
  color: #303133;
  margin-bottom: 10px;
}

.section-header p {
  color: #606266;
  font-size: 1.1em;
}

.app-container {
  min-height: 100vh;
}
</style> 